import {
  BOT_CONTROL_P_SERVED,
  getSystemBots,
  isSystemBotPServed,
  type SystemBotInfo,
} from '@wui/im'

import { Contact } from '@/shared/types/api'

export { BOT_CONTROL_P_SERVED }

const normalizeBotSearchText = (value: string): string => {
  return value.toLowerCase().replace(/[-_<>:@.\s]/g, '')
}

export const systemBotToContact = (bot: SystemBotInfo): Contact => ({
  id: bot.pServed,
  name: bot.name,
  internalNumber: '',
  groupIds: [],
  organization: bot.description,
  position: null,
  imLogin: bot.pServed,
  terminalLogin: '',
  terminalPassword: '',
})

export const getSystemBotContact = (pServed: string | undefined | null): Contact | undefined => {
  if (!pServed) {
    return undefined
  }

  const bot = getSystemBots().find(item => item.pServed === pServed)
  return bot ? systemBotToContact(bot) : undefined
}

export const matchesSystemBotSearch = (query: string, bot: SystemBotInfo): boolean => {
  const trimmed = query.trim()
  if (!trimmed) {
    return false
  }

  const lower = trimmed.toLowerCase()
  const normalized = normalizeBotSearchText(trimmed)
  const fields = [bot.name, bot.publicIdentity, bot.pServed, bot.description]

  return fields.some(field => {
    const fieldLower = field.toLowerCase()
    return fieldLower.includes(lower) || normalizeBotSearchText(field).includes(normalized)
  })
}

export const matchesSystemBotPServedQuery = (query: string, pServed: string): boolean => {
  const bot = getSystemBots().find(item => item.pServed === pServed)
  return !!bot && matchesSystemBotSearch(query, bot)
}

export const matchesSystemBotContactSearch = (contact: Contact, query: string): boolean => {
  if (!isSystemBotPServed(contact.imLogin)) {
    return false
  }

  return matchesSystemBotPServedQuery(query, contact.imLogin)
}

export const findMatchingSystemBotContacts = (query: string): Contact[] => {
  return getSystemBots()
    .filter(bot => matchesSystemBotSearch(query, bot))
    .map(systemBotToContact)
}

export const mergeSystemBotSearchResults = (query: string, contacts: Contact[]): Contact[] => {
  const bots = findMatchingSystemBotContacts(query)
  if (bots.length === 0) {
    return contacts
  }

  const existingIds = new Set(contacts.map(contact => contact.id))
  return [...bots.filter(bot => !existingIds.has(bot.id)), ...contacts]
}
